<template>
	<div id="main">
		<div class="bg-other user-head-info">
			<div class="user-info clearfix">
				<div class="user-pic" data-is-fans="0" data-is-follows="">
					<div class="user-pic-bg">
						<img class="img" :src="this.$store.state.sessionInfo.headimgurl" alt="">
					</div>
				</div>
				<div class="user-info-right">
					<h3 class="user-name clearfix">
						<span>{{this.$store.state.sessionInfo.wxNickName}}</span>
						</h3>
					<p class="about-info">
						<span>{{this.$store.state.sessionInfo.roleInfo.roleName}}</span>
					</p>
				</div>
				<div class="study-info clearfix">
					<div class="item follows">
						<div class="u-info-learn" title="学习时长28时11分" style="cursor:pointer;">
							<em>0</em>
							<span>学习时长 </span>
						</div>
					</div>
					<div class="item follows">
						<a href="#"><em>0</em></a>
						<span>学习次数</span>
					</div>
					<div class="item follows">
						<a href="#"><em>1</em></a>
						<span>班级</span>
					</div>
					<div class="item follows">
						<a href="#"><em>10</em></a>
						<span>学生</span>
					</div>
				</div>
			</div>
		</div>
		<div class="wrap">
			<div class="slider">
				<ul>
					<li v-for="(item,key) of classList" :key="item.id">
						<a href="javascript:void(0)" :class="{active:item.id==cid}" v-on:click="qh(item.id,item.className)">
							<span>{{item.className}}</span><b class="icon-drop_right"></b>
						</a>
					</li>
					<li>
						<div class="tc-label">
							<img :src="teacherInfo.headimgurl" class="rounded" />
							<p>{{teacherInfo.userDesc}}</p>
						</div>
					</li>
				</ul>
			</div>
			<div class="u-container">
				<div class="nav">
					<div class="left-nav">
						<span class="title active">{{cname}}<span class="t1">|</span>
						<a href="javascript:void(0)" @click="tolive"><span class="t2"><i class="fa fa-users"></i>加入班级直播间</span></a>
						</span>
					</div>
				</div>
				<div class="course-floor clearfix">
					<div class="card card-st" v-for="(item,key) of userList" :key="item.id">
						<div href="javascript:void(0)" class="card-course is-auth">
							<div class="card-course-top hashadow"><img :src="item.userInfo.headimgurl" class="course-banner"></div>
							<div class="course-card-content">
								<h3 class="course-card-name">{{item.userInfo.wxNickName}}</h3>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		name: 'LearnCenterContent',
		data() {
			return {
				classList: [],
				userList: [],
				cid: null,
				cname: null,
				teacherInfo: null
			}
		},
		methods: {
			qh(cid, cname) {
				this.cid = cid
				this.cname = cname
				this.queryByClassId(this.cid)
			},
			queryByClassId(cid) {
				axios.get('/itmswcn/userClass/class/query/' + cid)
					.then(this.queryByClassIdSucc)
			},
			queryByClassIdSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					this.userList = data
					this.teacherInfo = this.userList[0].classInfo.teacherInfo
				}
			},
			tolive() {
				axios.get('/itmswcn/maintain/classLive/queryRoom/' + this.cid)
					.then(this.getRoomSucc)
			},
			getRoomSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					window.open("https://itmsw.cn/live/live.html?cid=" + data.classId + "&rid=" + data.roomId + "&rstr=" + data.randStr)
				} else {
					$.alert({
						title: '',
						content: '<span class="itmsw_ft_1" style="line-height:36px;"><i class="fa fa-check-square-o"></i> 抱歉，您还没有直播课<br>&nbsp;&nbsp;&nbsp;&nbsp;详情请咨询授课老师。</span>',
						theme: 'modern',
						closeIcon: false,
						animation: 'scale',
						type: 'blue',
						boxWidth: '380px',
						useBootstrap: false,
						backgroundDismiss: true,
						buttons: {
							yes: {
								text: '确认', // text for button
								btnClass: 'itmsw_bt_confirm_3', // class for the button
								keys: ['y'], // keyboard event for button
								isHidden: false, // initially not hidden
								isDisabled: false, // initially not disabled
								action: function(yesButton) {}
							}
						}
					});
				}
			},
			tochart() {
				window.open("https://itmsw.cn/chart/home.html")
			},
			getDataInfo() {
				axios.get('/itmswcn/maintain/classInfo/queryStList')
					.then(this.getDataInfoSucc)
			},
			getDataInfoSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					this.classList = data
					this.cid = data[0].id
					this.cname = data[0].className
					this.queryByClassId(this.cid)
				}
			}
		},
		mounted() {
			this.getDataInfo()
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/teach/components/TeachCenterContent.scss';
</style>